import { useCallback, useContext } from 'react';
import { ParentContext } from '../ParentContext';
import { allPageTypes } from 'global/enums/allPageTypes';

const usePageFunctions = () => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state, paps_state, page_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});

  const getGviDeps = useCallback((uivi, viewKey) =>
    get_gviDeps(
      aps_viewItems,
      uivi,
      viewKey,
      aps_page
    ),
    []
  );

  const getViRef = useCallback((uivi, viewKey) =>
    get_viRef(
      aps_viewItems,
      uivi,
      viewKey,
      pathViews,
      aps_page
    ),
    []
  );

  const syncViewItems = useCallback((gvs, vis, vs) =>
    sync_viewItems(
      gvs,
      vis,
      vs
    ),
    []
  );

  const getVi = useCallback((vi, isGlobal) =>
    get_vi(
      vi,
      isGlobal,
      page_state
    ),
    [page_state]
  );

  const getLink = useCallback((appUrlz, name, isMobileDevice) =>
    get_link(
      appUrlz,
      name,
      isMobileDevice
    ),
    []
  );


  return {
    getGviDeps,
    getViRef,
    syncViewItems,
    getVi,
    getLink
  };

};

export default usePageFunctions;

const get_viRef = (aps_viewItems, uivi, viewKey, pathViews, aps_page) => {
  const viDeps = get_gviDeps(aps_viewItems, uivi, viewKey, aps_page)
  const baseRef = getBaseRef(viDeps, pathViews)
  return baseRef
}

const get_vi = (vi, isGlobal, currentSettings_state) => {
  const { aps_page, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { viewItems } = aps_page ?? {}
  return isGlobal ? aps_viewItems[vi] : viewItems[vi]
}

const get_gviDeps = (aps_viewItems, uivi, viewKey, aps_page) => {

  const viewItem_page = aps_page && aps_page.viewItems && aps_page.viewItems[uivi] ? aps_page && aps_page.viewItems && aps_page.viewItems[uivi] : null;
  const viewItem_app = aps_viewItems && aps_viewItems[uivi] && aps_viewItems[uivi] ? aps_viewItems[uivi] : null

  // dataSource 
  const { dataConstraints, dataSource } = viewItem_page ?? {}
  const _dataConstraints = dataConstraints ? dataConstraints : dataSource
  const { dataParents: dataParents_page, useSeasonals, dataLinkType, useSubDataCollection, subDataCollectionName } = _dataConstraints ?? {}
  const { dependencies, documentDependencies, dataParents } = viewItem_app && viewItem_app.dataConnection ? viewItem_app.dataConnection : {}

  if (dependencies || dataParents || dataParents_page) {
    const dpp = dataParents_page ? dataParents_page : dataParents
    return { dependencies, documentDependencies, dataParents: dpp, useSeasonals, dataLinkType, useSubDataCollection, subDataCollectionName }
  } else {
    let deps = null
    switch (uivi) {
      case allPageTypes.home:
        break;

      case allPageTypes.clients:
        if (viewKey) {
          deps = [allPageTypes.clients]
        }
        break;

      case allPageTypes.events:
        deps = [allPageTypes.clients]
        break;

      default:
        // deps = null
        deps = [allPageTypes.clients, allPageTypes.events]
        break;
    }

    return { dependencies: deps, documentDependencies, dataParents: null, useSeasonals, dataLinkType, useSubDataCollection, subDataCollectionName }
  }
}

const get_link = (appUrlz, name, isMobileDevice) => {
  const x = _.find(appUrlz, { appName: name })
  if (x) {
    if (!isMobileDevice) {
      if (x.appDesktopUrl) {
        return x.appDesktopUrl
      } else {
        return x.appUrl
      }
    } else {
      return x.appUrl
    }
  }
}

const sync_viewItems = (gvs, vis, vs) => {
  const { viewItems } = vs ?? {}
  if (vis && viewItems) {
    Object.keys(viewItems).forEach(key => {
      const vi = viewItems[key]
      const gvi = vis[key]
      if (gvi) {
        if (!vi.key) { vi.key = key }
        if (!gvi.key) { gvi.key = key }
        if (vi && gvi) {
          Object.keys(vi).forEach(k => {
            const vii = vi[k]
            const gii = gvi[k]
            if (vii && gii && _.isObject(vii) && _.isObject(gii) && Object.keys(vii).length > 0 && Object.keys(gii).length > 0) {
              switch (k) {
                case 'display':
                  vii.caption = vii.caption ? vii.caption : gii.caption
                  vii.defaultIcon = gii.defaultIcon
                  break;
                // case 'ui':
                //   vii.caption = vii.caption ? vii.caption : gii.caption
                //   vii.defaultIcon = gii.defaultIcon
                //   break;
                default:
                // nothing
              }
            }
          })
        }
      }

    })
  }
}
